import {IAnimeFavoriteJson, IListStatus, IUserAnimeInfo} from "../../../../nodeserver/structs/database";
import {handleFetchError, showNotice} from "../helpers/functions.js";
import {ServerApi} from "../api.js";
import {fuzzysort} from "../helpers/fuzzysearch.js";
import JSX from "../helpers/react.js";
import { favoriteTypes } from "../config.js";
type SortFunc =  (a: IAnimeFavoriteJson, b: IAnimeFavoriteJson)=>number;
type FilterFunc =  (a: IAnimeFavoriteJson)=>boolean;

function Rating(props: {anime: IAnimeFavoriteJson}){
    let rating = props.anime.rating.toFixed(2);
    if(rating === '10.00') rating = '10.0';
    if(props.anime.rating && props.anime.anime_status.alias !== 'announcement')
        return (
            <span className="title-rating"
                  data-balloon="Рейтинг аниме"
                  data-balloon-pos={window.innerWidth > 830?"left":undefined}>
                <i className="fa fa-star" />
                {rating}
            </span>
        );
    else
        return (
            <span className="title-rating" style={{visibility: 'hidden'}}>
                <i className="fa fa-star" />
                {rating}
            </span>
        )
}
function FavoriteIcon({isFav}: {isFav: boolean}){
    if(isFav) return (
        <span className="favorite-icon addtofavourite active"
              data-balloon={window.innerWidth > 830?("В любимых"):undefined}
              data-balloon-pos={window.innerWidth > 830?"left":undefined}>
            <i className="fa fa-heart" />
        </span>
    )
    return (
        <span className="favorite-icon addtofavourite"
                 data-balloon={window.innerWidth > 830?("В любимых"):undefined}
                 data-balloon-pos={window.innerWidth > 830?"left":undefined}>
            <i className="fa fa-heart" />
        </span>
    )
}
function UserRating(props: {anime: IAnimeFavoriteJson, OnClick: ()=>any}) {
    if(props.anime.user.rating)
        return (
            <span data-balloon={window.innerWidth > 830?(user_id==page_id?"Мой рейтинг":"Рейтинг пользователя"):undefined}
                  data-balloon-pos={window.innerWidth > 830?"left":undefined}
                  data-id={props.anime.anime_id}
                  className={`user-rating rating-${props.anime.user.rating}`} onClick={e=>(e.preventDefault(),props.OnClick())}>
                <i className="fa fa-star" /> {props.anime.user.rating}
            </span>
        )
    return (
        <span style={{visibility: 'hidden'}}
              data-id={props.anime.anime_id}
              className="user-rating">
            <i className="fa fa-star" /> 0
        </span>
    );

}
function NextEpisodeCounter(props: {anime: IAnimeFavoriteJson}){
    if(props.anime.anime_status.alias !== 'released' && props.anime.next_episode)
        return (<time-counter start="" data-title="Дата выхода следующего эпизода: $0" data-time={props.anime.next_episode} className="next-ep"/>)
    return <></>
}
function ListActionBtn({text, className, animeId, OnAddToListClick}: { text: string, className: string[], animeId: number, OnAddToListClick: ()=>any }) {
    return (
        <button data-id={animeId} title={text} className={[...className, 'list-button']} onClick={OnAddToListClick} />
    );
}
function Buttons(props: {val: IAnimeFavoriteJson, isFavList: boolean, OnFavClick: ()=>any, OnAddToListClick: (listId: number)=>any, OnDeleteClick: ()=>any}){
    const btns: HTMLElement[] = [];
    if(props.isFavList){
        btns.push(
            <ListActionBtn animeId={props.val.anime_id} text="Любимое" className={['addtofavourite', 'far', 'fa-heart', ...(props.val.user.list.is_fav?['active']:[])]}
                           OnAddToListClick={props.OnFavClick} />

    //     <button data-id={props.val.anime_id} title="Любимое" className={`addtofavourite far fa-heart${props.val.user.list.is_fav ? ' active' : ''}`}
    //                 onClick={props.OnFavClick}
    //         />
        );
    }
    else {
        if (props.val.user.list.list?.id !== 0)
            btns.push(
                <ListActionBtn animeId={props.val.anime_id} text="Смотрю" className={['list-watch-now', 'far', 'fa-eye']}
                               OnAddToListClick={()=>props.OnAddToListClick(0)} />
        // <button data-id={props.val.anime_id} title="Смотрю" className="list-watch-now far fa-eye"
        //                 onClick={()=>props.OnAddToListClick(0)}
        //         />
            );
        if (props.val.user.list.list?.id !== 1)
            btns.push(
                <ListActionBtn animeId={props.val.anime_id} text="Буду смотреть" className={['list-will-watch', 'far', 'fa-cloud']}
                               OnAddToListClick={()=>props.OnAddToListClick(1)} />

        // <button data-id={props.val.anime_id} title="Буду смотреть" className="list-will-watch list-button far fa-cloud"
        //                 onClick={()=>props.OnAddToListClick(1)}
        //         />
            );
        if (props.val.user.list.list?.id !== 2)
            btns.push(
                <ListActionBtn animeId={props.val.anime_id} text="Просмотреть" className={['list-watched', 'far', 'fa-flag-checkered']}
                               OnAddToListClick={()=>props.OnAddToListClick(2)} />
        //
        // <button data-id={props.val.anime_id} title="Просмотреть" className="list-watched list-button far fa-flag-checkered"
        //                 onClick={()=>props.OnAddToListClick(2)}
        //         />
            );
        if (props.val.user.list.list?.id !== 3)
            btns.push(
                <ListActionBtn animeId={props.val.anime_id} text="Броcить" className={['list-lost', 'far', 'fa-eye-slash']}
                               OnAddToListClick={()=>props.OnAddToListClick(3)} />
        //
        // <button data-id={props.val.anime_id} title="Брошено" className="list-lost list-button far fa-eye-slash"
        //                 onClick={()=>props.OnAddToListClick(3)}
        //         />
            );
        if(props.val.user.list.list?.id !== 5){
            btns.push(
                <ListActionBtn animeId={props.val.anime_id} text="Отложить" className={['list-postponed', 'far', 'fa-history']}
                               OnAddToListClick={()=>props.OnAddToListClick(5)} />
                // <button data-id={props.val.anime_id} title="Отложено" className="list-lost list-button far fa-history"
                // />
            );
        }
        btns.push(
            <ListActionBtn animeId={props.val.anime_id} text="Любимое" className={['addtofavourite', 'far', 'fa-heart', ...(props.val.user.list.is_fav?['active']:[])]}
                           OnAddToListClick={props.OnFavClick} />

        // <button data-id={props.val.anime_id} title="Любимое" className={`addtofavourite far fa-heart${props.val.user.list.is_fav ? ' active' : ''}`}
        //             onClick={props.OnFavClick}
        //     />
        );
        btns.push(
            <ListActionBtn animeId={props.val.anime_id} text="Удалить из списка" className={['list-remove', 'far', 'fa-trash']}
                           OnAddToListClick={props.OnDeleteClick} />

        // <button data-id={props.val.anime_id} title="Удалить из списка" className="list-remove far fa fa-trash"
        //             onClick={props.OnDeleteClick}
        //     />
        );
    }
    return (
        <div className="list-buttons">
            <div className="list-buttons-control list-button fa fa-cog" />
            <div className="list-buttons-list">
                {...btns}
            </div>
        </div>
    );

}
function ProfileList(props: {anime: IAnimeFavoriteJson, isFavList: boolean, OnFavClick: ()=>any, OnAddToListClick: (listId: number)=>any, OnDeleteClick: ()=>any, OnUserRatingClick: ()=>any}) {
   return(
       <li className="profile-list"
           title={`Добавлено в список ${convertTime(props.anime.date)}`}>
            <a href={`/catalog/item/${props.anime.anime_url}`}>
                <img src={props.anime.poster.small} data-big={props.anime.poster.big} data-medium={props.anime.poster.medium} className="update-img" loading="lazy" alt="" />
                <span className="update-list-block">
                    <span className={`dote ${props.anime.anime_status.class}`} title={`Статус: ${props.anime.anime_status.title}`} />
                    <span className="update-title">{props.anime.title}</span>
                    <Rating anime={props.anime} />
                    <UserRating anime={props.anime} OnClick={props.OnUserRatingClick}/>
                    <FavoriteIcon isFav={props.anime.user.list.is_fav}/>
                    <NextEpisodeCounter anime={props.anime} />
                </span>
                {
                    user_id == page_id &&
                    <Buttons
                        val={props.anime}
                        isFavList={props.isFavList}
                        OnFavClick={props.OnFavClick}
                        OnAddToListClick={props.OnAddToListClick}
                        OnDeleteClick={props.OnDeleteClick}
                    />
                }
            </a>
        </li>
   );

}
function NotFound(){
    return (<div className="center not-found bordered-bottom">
        <p>Ничего не найдено.</p>
        {
            user_id==page_id && <p>Вы можете добавить аниме из каталога<br /></p>
        }
        {
            user_id == page_id ?
                <p><a className="main-button bordered" style={{padding: "5px 10px"}} href="/catalog">Перейти в каталог</a></p>:
                <p><span><span className="second-marker">{$('.block-title .second-marker').text()}</span> ещё не добавил аниме в этот список.</span></p>
        }
    </div>);
}
class OneList{
    private $element!: HTMLElement;
    private deleted: boolean = false;
    constructor(public readonly val: IAnimeFavoriteJson, private readonly isFavList: boolean=false) {}
    buildHtml(): HTMLElement{
        const ans = <ProfileList
            anime={this.val}
            isFavList={this.isFavList}
            OnFavClick={this.toggleFav}
            OnAddToListClick={listId => this.addToList(listId)}
            OnDeleteClick={this.remove}
            OnUserRatingClick={this.removeRating}
        />;
        return this.$element=ans
    }
    public remove = async () => {
        let animeId = this.val.anime_id;
        try {
            let response: { response: { list?: any; } | true };
            if (!this.deleted) {
                if (this.isFavList) {
                    response = await ServerApi.anime.list.removeFavorite(animeId);
                    OneList.totalCountDesc(4);
                    if(this.val.user.list.list)
                        ListsLoader.getLoader(user_id!)?.toggleFav(this.val.user.list.list, this.val.anime_id);
                }
                else {
                    response = await ServerApi.anime.list.removeIt(animeId);
                    OneList.totalCountDesc(this.val.user.list.list?.id??-1);
                }
            }
            else {
                if (this.isFavList) {
                    OneList.totalCountInc(4);
                    response = await ServerApi.anime.list.setFavorite(animeId, this.createDate);
                    ListsLoader.getLoader(user_id!)?.toggleFav(this.val.user.list.list!, this.val.anime_id);
                }
                else {
                    OneList.totalCountInc(this.val.user.list.list!.id);
                    response = await ServerApi.anime.list.setIt(animeId, this.val.user.list.list!.id, this.createDate);
                }
            }
            $(this.$element).toggleClass('deleted')
                .find('.list-remove')
                .toggleClass('fa-trash fa-undo');
            $(this).data('deleted', this.deleted = !this.deleted);
            if (this.deleted)
                showNotice(`Аниме удалено из списков`, '-_-');
            else showNotice(<>Аниме вновь добавлено в список «{(response.response as { list: string }).list}»</>, '\\(-_-)/', 'success')
        }
        catch (e) {
            handleFetchError(e);
        }
    }
    private get createDate(): number{
        return this.val.date;
        // return this.$element.data('createdat') as number;
    }
    public toggleFav = async(fetchData: boolean=true) =>{

        if(this.isFavList) return this.remove();
        $(this.$element).find('.addtofavourite').toggleClass('active');
        this.val.user.list.is_fav = !this.val.user.list.is_fav;
        // TODO: if favorites lists is loaded
        if(fetchData) {
            try {
                if (!this.val.user.list.is_fav) {
                    await ServerApi.anime.list.removeFavorite(this.val.anime_id);
                    showNotice("Аниме удалено из списка «любимые».", "-_-");
                    OneList.totalCountDesc(4);
                    ListsLoader.getLoader(user_id!).dropList(4);
                } else {
                    await ServerApi.anime.list.setFavorite(this.val.anime_id, this.createDate);
                    showNotice("Аниме добавлено в список «любимые» !", "(☞ﾟヮﾟ)☞", 'success');
                    OneList.totalCountInc(4);
                    ListsLoader.getLoader(user_id!).dropList(4);
                }
            } catch (e) {
                handleFetchError(e);
                this.val.user.list.is_fav = !this.val.user.list.is_fav;
                $(this.$element).find('.addtofavourite').toggleClass('active')
            }
        }
    }
    public set enabled(val: boolean){
        this.$element.style.display = val?'':'none';
    }

    private static totalCountDesc(listId: number){
        const $el = $(`.li-profile[data-listid=${listId}] .count`),
            $totalCountEl = $(".total-anime-count");
        $el.text(+($el.text()||1)-1);
        $totalCountEl.text(+($totalCountEl.text()||1)-1);

    }
    private static totalCountInc(listId: number){
        const $el = $(`.li-profile[data-listid=${listId}] .count`),
            $totalCountEl = $(".total-anime-count");
        $el.text(+($el.text()||0)+1);
        $totalCountEl.text(+($totalCountEl.text()||0)+1);
    }

    public async addToList(listId: number){
        try{
            await ServerApi.anime.list.setIt(this.val.anime_id, listId);
            this.$element.remove();
            OneList.totalCountDesc(this.val.user.list.list!.id);
            OneList.totalCountInc(listId);
            // ListsLoader.getLoader(page_id!).dropList(listId);
            if(!this.isFavList)
                ListsLoader.getLoader(page_id!).addNewItem(this.val, favoriteTypes.find(e=>e.id===listId)??null)
            // TODO: move to other list
        }
        catch (e){
            handleFetchError(e);
        }
    }

    /**
     * Move current element to the end of parent
     */
    public setLastEl() {
        this.$element.parentElement!.appendChild(this.$element);
    }

    public removeRating = async ()=> {
        if (user_id == page_id && confirm('Удалить свой рейтинг?')) {
            await ServerApi.anime.rate.removeRate(this.val.anime_id);
            const el = this.$element.querySelector('.user-rating');
            this.val.user.rating = 0;
            $(el!).replaceWith(<UserRating anime={this.val} OnClick={this.removeRating} />)

            showNotice("Рейтинг удалён", "Успех");
        }
    }
}
class ListsLoader{
    private lists: Map<number, OneList[]> = new Map();
    private loaded: Boolean = false;
    private constructor(private readonly userId: number) {

    }
    private static Instances: Map<number, ListsLoader> = new Map();
    static getLoader(userId: number): ListsLoader{
        return this.Instances.get(+userId) ?? this.Instances.set(+userId, new ListsLoader(+userId)).get(+userId)!;
    }
    public async loadList(listId: number, $this: JQuery){
        if(this.lists.has(listId)) return;
        try{
            const $appendTo = $($this.data('id')+' .update-list')
                .html(
                    <div className="filter-body" style={{
                        textAlign: 'center',
                        padding: '20px 15px',
                        background: "var(--background-first)"
                    }}>
                        <i className="loading large" />
                    </div>
                );

            const data = await ServerApi.users.getLists(this.userId, listId);
            data.sort(this._sortByFunc).reverse();
            this.lists.set(listId, data.map(it=>new OneList(it, listId === 4)));
            $appendTo.text('');
            const appendTo = $appendTo[0];
            for(let list of this.lists.get(listId)!) {
                appendTo.appendChild(list.buildHtml())
                    // .appendTo()
            }
            // if(!appendTo.children.length) $appendTo.html(<NotFound />)
            this.loaded = true;
            clearSearch();

        }catch (e){
            handleFetchError(e);
        }

    }
    public dropList(listId: number){
        this.lists.delete(listId)
    }
    private _sortByFunc: SortFunc = (a,b) => a.date-b.date;
    private _filterFunc: FilterFunc = (a) => true;
    public sortBy(lambda: SortFunc|null=null){
        lambda ??= this._sortByFunc;
        this._sortByFunc = lambda;
        for(let lists of this.lists.values()){
            lists.sort((a,b)=>lambda!(a.val, b.val));
            for(let i=lists.length-1; i>=0; i--){
                const el = lists[i];
                //move element to the end
                el.setLastEl();
            }
        }
    }
    public filterBy(lambda: FilterFunc|null=null){
        lambda ??= this._filterFunc;
        for(const [listId, list] of this.lists.entries()){
            let enabled = false;
            for(let el of list){
                const enabledCurr =  el.enabled = lambda(el.val);
                enabled ||= enabledCurr;
            }
            const $content = $(`.lists-content>.tab-content:has(.update-list[data-listid=${listId}])`)
            if(!enabled) {
                const $notFound = $content.children('.not-found');
                if(!$notFound[0])
                    $content[0].prepend(<NotFound />);
                else $notFound.css('display','')
            }
            else {
                $content.find('.not-found').css('display', 'none');
            }
        }
    }

    public addNewItem(val: IAnimeFavoriteJson, newListId: IListStatus|null) {
        const oldIndex = this.lists.get(val.user.list.list?.id??-1)?.findIndex(e=>e.val.anime_id === val.anime_id)??-1;
        this.lists.get(val.user.list.list!.id)!.splice(oldIndex, 1);
        if(!this.lists.has(newListId?.id??-1)) return;
        val.user.list = {
            list: newListId!.id!==4 ? newListId:val.user.list.list,
            is_fav: val.user.list.is_fav
        }
        const list = new OneList(val, newListId!.id === 4);


        const $appendTo = $(`.update-list[data-listid=${newListId?.id}]`);
        $appendTo[0].appendChild(list.buildHtml());

        this.lists.get(newListId!.id)!.push(list)

        this.sortBy();
    }

    public toggleFav(value: (IListStatus|null), animeId: number) {
        this.lists.get(value?.id??-1)?.find(e=>e.val.anime_id === animeId)?.toggleFav(false);
    }
}
(window as any).ListsLoader = ListsLoader;
$('html').on('click', '#remote-lists .tabs > li',async function () {
    const $this = $(this),
        list_id = $this.data('listid');
    $(this).parent().parent().find('select.slim-select').each(function () {
        const that = $(this);
        //@ts-ignore
        that.slimSet(that.data('default') || 0);
    });
    await ListsLoader.getLoader(page_id!).loadList(+list_id, $this);
})
    //clear profile search
    .on('click', '.profile-filter-search-clear', clearSearch)
    .on('keyup', '.profile-search', function () {
        const that = $(this);
        if ((that.val()! as string).length > 0) {
            that.prev().show();
        } else {
            that.prev().hide();
        }
        SortFilterAdapter.Instance.filterList();
    })
    .on('change', '.profile-type,.profile-categories', function(){
        SortFilterAdapter.Instance.filterList();
    })
    .on('click', '.list-buttons', function(e){
        //prevent link click
        e.preventDefault();
    })
    .on('click', '.list-buttons-control', function(){$(this).next().toggleClass('open');})
    // .on('click', '.list-buttons .list-remove', async function(){
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //     await list.remove();
    // })
    // .on('click', '.list-buttons .list-lost', async function(){
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //     await list.addToList(3);
    // })
    // .on('click', '.list-buttons .list-watched', async function (){
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //     await list.addToList(2);
    // })
    // .on('click', '.list-buttons .list-will-watch', async function(){
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //     await list.addToList(1);
    // })
    // .on('click', '.list-buttons .list-watch-now', async function(){
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //     await list.addToList(0);
    // })
    .on('change', '.profile-sort', function(){
        const sortId: number = +$(this).val()!;
        SortFilterAdapter.Instance.sortById(sortId);
    })
    // .on('click', '.profile-list .user-rating', async function (e) {
    //     e.preventDefault();
    //     const oneListEl = $(this).parents('.profile-list'),
    //         list: OneList = oneListEl.data('list') as OneList;
    //
    //     try {
    //         await list.removeRating();
    //     }catch (e){
    //         handleFetchError(e);
    //     }
    // })

interface FilterData{
    searchString?: string;
    genres: number[];
    animeTypes: number[];
}
class SortFilterAdapter{
    private constructor() {}

    private getFilterData(): FilterData{
        const ans: FilterData = {
            genres: Array.from($('select.profile-categories option:selected') as JQuery<HTMLOptionElement>)
                .map(e=>+e.value),
            animeTypes: Array.from($('select.profile-type option:selected') as JQuery<HTMLOptionElement>)
                .map(e=>+e.value)
        };
        const searchString = $('.profile-search').val()! as string;
        if(searchString) ans.searchString = searchString.replaceAll('ё', "е");
        return ans;
    }
    public get sortVal(): number{
        return +(localStorage.defaultAnimesSort||1);
    }
    private set sortVal(val: number){
        localStorage.defaultAnimesSort = val+"";
    }
    static Instance = new SortFilterAdapter();
    public filterList() {
        const filterData = this.getFilterData();
        ListsLoader.getLoader(page_id!)
            .filterBy(element =>{
                for(const needGenre of filterData.genres){
                    if(!element.genres.some(e=>e.id === needGenre)) return false;
                }
                if(filterData.searchString){
                    const res = fuzzysort.single(filterData.searchString, element.title.replaceAll('ё', 'е'))
                    if(!res) return false;
                }
                if(filterData.animeTypes.length){
                    if(!filterData.animeTypes.some(e=>e === element.type.value)) return false;
                }
                return true;
            });

    }

    public triggerSortUpdate(){
        $(".profile-sort").prop('slim')?.setSelected(this.sortVal+"");
    }
    public sortById(id: number){
        this.sortVal = id;
        const collator = new Intl.Collator("ru", {ignorePunctuation: true}),
            loader = ListsLoader.getLoader(page_id!);
        switch (id) {
            case 1:
                loader.sortBy((a,b)=>collator.compare(b.title, a.title))
                break;
            case 2:
                loader.sortBy((a,b) =>collator.compare(a.title, b.title));
                break;
            case 3:
                loader.sortBy((a,b) =>(a.date- b.date));
                break;
            case 4:
                loader.sortBy((a, b)=>(a.rating-b.rating+0.000000001) ||(a.user.rating-b.user.rating))
                break;
            case 5:
                loader.sortBy((a, b)=>(a.user.rating-b.user.rating+0.000000001) || (a.rating-b.rating))
                break;
            case 6:
                const now = +new Date/1000;
                loader.sortBy((a, b) => {
                    if(a.anime_status.alias === 'released') return -1;
                    if(b.anime_status.alias === 'released') return 1;
                    if(!a.next_episode || a.next_episode < now) return -1;
                    if(!b.next_episode || b.next_episode < now) return 1;
                    return b.next_episode - a.next_episode;
                })
            default:
                return console.warn("Undefined sort method!");
        }
    }

}
$(()=>{
    //Set default sort from localStorage
    setTimeout(()=>SortFilterAdapter.Instance.triggerSortUpdate())
//    ;
});


function clearSearch() {
    $('.profile-filter-search-clear').hide().next().val('');
    SortFilterAdapter.Instance.filterList();
}